<template>
  <nav>
    <ol itemscope itemtype="https://schema.org/BreadcrumbList">
      <li itemprop="itemListElement" itemscope itemtype="https://schema.org/ListItem">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960"><path d="M180-140v-450l300-225.77L780-590v450H556.15v-267.69h-152.3V-140H180Z"/></svg>
        <a to="/" itemprop="item"><span itemprop="name">ガードワークス</span></a>
        <meta itemprop="position" content="1">
      </li>
      <li v-for="(item, index) in list" :key="index" itemprop="itemListElement" itemscope itemtype="https://schema.org/ListItem">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960"><path d="m517.85-480-184-184L376-706.15 602.15-480 376-253.85 333.85-296l184-184Z"/></svg>
        <a :href="item.link" itemprop="item" v-if="item.link"><span itemprop="name">{{ item.title }}</span></a>
        <span itemprop="item" v-else><span itemprop="name">{{ item.title }}</span></span>
        <meta itemprop="position" :content="index + 2">
      </li>
    </ol>
  </nav>
</template>

<style lang="scss" scoped>
nav{
  background: module.$gray;
  box-shadow: .8rem .8rem 1.6rem rgba(module.$normal,.1);
  padding: .9rem 2rem;
  border-radius: 999rem;
  @media screen and (max-width: module.$phone){
    padding: .64rem 1.2rem;
    border-radius: 0 999rem 999rem 0;
    box-shadow: .4rem .4rem 2.4rem rgba(module.$normal,.2);
  }
  ol{
    @include module.flex();
    align-items: center;
    justify-content: flex-start;
    li{
      @include module.flex();
      align-items: center;
      justify-content: flex-start;
      font-size: .8rem;
      @media screen and (max-width: module.$phone){
        font-size: .64rem;
      }
      &:first-child{
        svg{
          width: 1.24rem;
          height: 1.24rem;
          margin: 0 .4rem 0 0;
          fill: module.$normal;
          @media screen and (max-width: module.$phone){
            width: 1rem;
            height: 1rem;
          }
        }
      }
      svg{
        width: 1rem;
        height: 1rem;
        display: inline-block;
        margin: 0 .8rem;
        @media screen and (max-width: module.$phone){
          margin: 0 .4rem;
        }
      }
    }
  }
}
</style>

<script>
export default {
  props: {
    list: {
      type: Array,
      required: true
    },
  }
}
</script>
